import Epic from "../components/Epic";

const EpicPage = () => {
  return (
    <div className="container mx-auto">
      <Epic />
    </div>
  );
};

export default EpicPage;
